import { Component, ViewEncapsulation, ChangeDetectionStrategy, Input, OnInit, ViewChild, ElementRef, forwardRef, Output, EventEmitter, SimpleChanges } from '@angular/core';
import { ControlValueAccessor, AbstractControl, ValidationErrors, NG_VALUE_ACCESSOR, NG_VALIDATORS } from '@angular/forms';

/**
 * æé®ç»ä»¶ - ä¸»è²è°æé®ãå¯è²è°æé®ãåæ¶æé®ãå¯è®¾ç½®å®½åº¦æé®ãä¸ä¼ æä»¶æé®ç­
 * 
 * <example-url>https://stackblitz.com/edit/np-button-sample?embed=1&file=src/app/app.component.html</example-url>
 */
@Component({
  selector: `np-button`,
  templateUrl: 'button.html',
  styleUrls: ['button.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => NpButton),
      multi: true,
    },
  ]
})
export class NpButton implements OnInit, ControlValueAccessor {
  private onChange: Function;
  inputDom: HTMLInputElement;

  @ViewChild('npButton') npButton: ElementRef<HTMLElement>;
  /**æé®ç±»å
   * 
   * primary - ä¸»è²è°æé®ï¼å³Plutoè²ï¼secondary - å¯è²è°æé®ï¼cancel - åæ¶æé®ï¼search - æç´¢æé®
   */
  @Input() buttonType: 'primary' | 'secondary' | 'cancel' | 'search';
  /**
   * æé®å®½åº¦å¤§å° - large - 300pxï¼default - 180pxï¼small - 80pxã
   */
  @Input() buttonSize: 'large' | 'default' | 'small';
  /**
   * ç»§æ¿ç¶å®½åº¦ - `<np-button buttonBlock>ç»§æ¿ç¶å®½åº¦</np-button>`
   */
  @Input() buttonBlock: any;
  /**æ¯å¦ç¦ç¨æé®ã */
  @Input() isDisabled: boolean;

  // #region ä¸ä¼ æä»¶ç¸å³
  /**æé®åè½ç±»å - normal - é»è®¤ç±»åï¼upload - å³ä¸ºä¸ä¼ æä»¶ç±»åæé®ã
   */
  @Input() funcType: 'normal' | 'upload' = 'normal';
  /**ä¸ä¼ æä»¶ç±»åï¼ å¦ï¼[uploadFileType]="'jpg|png|jpeg'"ã
   * 
   * ç¹å«è¯´æä¸ä¸æ ¼å¼ï¼å ä¸ºéç¨æ­£åå¹éï¼æä»¥ä¼ å¥æ ¼å¼ä¸º'xlsx|xls'ï¼ç¨|éå¼ã
   */
  @Input() uploadFileType = '';
  /**äºè¿å¶æä»¶ã */
  @Input() file;
  /**æä»¶æ¹åè§¦åäºä»¶ï¼ å³ååç»å®ã */
  @Output() fileChange = new EventEmitter<any>();
  /**ä¸ä¼ æä»¶åºéæ¶æ¯äºä»¶ã */
  @Output() uploadErrorMessage = new EventEmitter<string>();
  // #endregion

  ngOnInit() {
    this.buttonType = this.buttonType || 'primary';
    this.buttonSize = this.buttonType === 'search' ? 'small' : this.buttonSize || 'default';
    const element = this.npButton.nativeElement;
    if (this.buttonType === 'search' && this.buttonSize === 'default') {
      this.buttonSize = 'small';
    }

    element.classList.add(`button-${this.buttonType}`);
    if (['large', 'default', 'small'].indexOf(this.buttonSize) > -1) {
      element.classList.add(`button-size-${this.buttonSize}`);
    } else {
      element.style.width = this.buttonSize;
    }

    if (this.buttonBlock === '') {
      const parentWidth = element.parentElement.parentElement.offsetWidth;
      element.style.width = `${parentWidth - 54}px`;
    }

    if (this.isDisabled) {
      element.classList.add('button-disabled');
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    const contentChange = changes['isDisabled'];
    if (contentChange) {
      const value = contentChange.currentValue;
      if (value) {
        this.npButton.nativeElement.classList.add('button-disabled');
      } else {
        this.npButton.nativeElement.classList.remove('button-disabled');
      }
    }
  }

  upload() {
    if (this.funcType === 'upload' && !this.isDisabled) {
      this.inputDom = document.createElement('input');
      this.inputDom.type = 'file';
      this.inputDom.onchange = (event: any) => {
        const file = event.currentTarget.files[0];
        const fileName = file.name;
        if (this.uploadFileType) {
          const reg = new RegExp(`\.(${this.uploadFileType.toLowerCase()})|.(${this.uploadFileType.toUpperCase()})$`);
          if (!reg.test(fileName)) {
            this.uploadErrorMessage.emit(`æä»¶æ ¼å¼ä¸å¯¹ï¼æ¯æ${this.uploadFileType}`);
            return;
          }
        }

        const obj = {};
        obj['fileName'] = fileName;
        obj['file'] = file;
        if (this.onChange) {
          this.onChange(file);
        }

        this.fileChange.emit(file);
      }
      this.inputDom.click();
    }
  }

  writeValue(obj: any): void {
    // clear file input
    if (this.inputDom) {
      document.removeChild(this.inputDom);
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
  }
}


